import styled from "styled-components";
import {useTranslation} from "react-i18next";
import useTitleAndDescription from "../../common/hooks/useTitleAndDescription";
import {Footer, Header, Loading} from "../common";
import {ErrorBoundary} from "react-error-boundary";
import CenterContentBox from "../Champions/ContentWrapper";
import React, {Suspense} from "react";
import BottomStickAd from "../ad/BottomStickAd";
import EventMangContent from "./EventMangContent";

const Wrapper = styled.div`
`;

const ContentWrapper = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;


function Fallback({error, resetErrorBoundary}) {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.

    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre>{error.message}</pre>
        </div>
    );
}

const EventMang = () => {
    const {t} = useTranslation();
    useTitleAndDescription({
        title: '2026 SOOP 멸망전 | DEEPLOL.GG',
        description: '2026년 SOOP 멸망전 팀 구성과 경기 결과를 한눈에 확인하세요.',
    })

    return (
        <Wrapper>
            <Header/>
            <ContentWrapper>
                <ErrorBoundary FallbackComponent={Fallback}>
                    <CenterContentBox disableSponsor={true}>
                        <Suspense fallback={<Loading/>}>
                            <EventMangContent/>
                        </Suspense>
                        {/*    <NewsContent/>*/}
                    </CenterContentBox>
                </ErrorBoundary>
            </ContentWrapper>
            <Footer/>
            <BottomStickAd/>
        </Wrapper>
    );
};


export default EventMang